 <p>
   <mat-toolbar class="mat-toolbar-height">
     <span>{{'settings.project.addGuest'|translate}}</span>
     <span class="user-spacer"></span>
     <button mat-icon-button mat-dialog-close="false">
       <mat-icon>close</mat-icon>
     </button>
   </mat-toolbar>
 </p>

 <form [formGroup]="guestUserForm">
   <mat-form-field appearance="outline" class="full-width">
     <mat-label>{{'form.email'|translate}}</mat-label>
     <input matInput formControlName="email" type="email">
     <mat-icon matSuffix>mail_outline</mat-icon>
     <mat-error *ngIf="guestUserForm.get('email')?.hasError('required')">
       {{'form.required_field'|translate}}
     </mat-error>
     <mat-error *ngIf="guestUserForm.get('email')?.hasError('email') && !guestUserForm.get('email')?.hasError('required')">
       {{'form.email_error'|translate}}
     </mat-error>
   </mat-form-field>


   <mat-form-field appearance="outline" class="full-width">
     <mat-label>{{'form.firstName'|translate}}</mat-label>
     <input matInput formControlName="firstName">
     <mat-icon matSuffix>person</mat-icon>
     <mat-error>{{'form.required_field'|translate}}</mat-error>
   </mat-form-field>

   <mat-form-field appearance="outline" class="full-width">
     <mat-label>{{'form.lastName'|translate}}</mat-label>
     <input matInput formControlName="lastName">
     <mat-icon matSuffix>person</mat-icon>
     <mat-error>{{'form.required_field'|translate}}</mat-error>
   </mat-form-field>

   <mat-form-field appearance="outline" class="full-width">
     <mat-label>{{'form.company'|translate}}</mat-label>
     <input matInput formControlName="company">
     <mat-icon matSuffix>business</mat-icon>
     <mat-error>{{'form.required_field'|translate}}</mat-error>
   </mat-form-field>

   <mat-form-field appearance="outline" class="full-width">
     <mat-label>{{'form.job'|translate}}</mat-label>
     <input matInput formControlName="job">
     <mat-icon matSuffix>card_travel</mat-icon>
     <mat-error>{{'form.required_field'|translate}}</mat-error>
   </mat-form-field>

   <mat-dialog-actions>
     <button mat-button type="submit" (click)="saveGuestUser()">{{'form.save'|translate}}</button>
     <button mat-button mat-dialog-close mat-dialog-close="false">{{'form.close'|translate}}</button>
   </mat-dialog-actions>
   <button mat-button color="fill" id="guest-user-btn"></button>
 </form>
